import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'components'
import styles from './PropertyData.module.scss'

const PropertyData = ({ register, rgi, subscription }) => {
  return (
    <div className={styles.propertyData}>
      <Text fontSize="medium">
        Matrícula:
        {register}
      </Text>
      <Text fontSize="medium">
        RGI:
        {rgi}
      </Text>
      <Text fontSize="medium">
        Inscrição Prefeitura:
        {subscription}
      </Text>
    </div>
  )
}

PropertyData.propTypes = {
  register: PropTypes.string.isRequired,
  rgi: PropTypes.string.isRequired,
  subscription: PropTypes.string.isRequired,
}

PropertyData.defaultProps = {}

export default React.memo(PropertyData)
